import { CreditorState } from '@debbie/common/dist/creditor/index.js'
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { CaseCreationStep } from '@debbie/iris/dist/components/CaseCreator/CaseCreator.js'
import { CaseCreator } from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'

type Props = {}

const genLink = (caseId: string | null, step: CaseCreationStep) => {
  return caseId != null ? `/create-case/${caseId}/${step}` : null
}

const CreateCase = (props: Props) => {
  const { caseId, slug }: { caseId: string; slug: CaseCreationStep } =
    useParams()

  const allCreditorsLoadable = useAllCreditors()
  const allCreditors = h.hasData(allCreditorsLoadable)
    ? allCreditorsLoadable.data
    : null
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  const creditor = allCreditors
    ? allCreditors.find((creditor) => creditor.creditorId === selectedCreditor)
    : null

  if (creditor?.state === CreditorState.Ceased) {
    return null
  }

  if (typeof caseId !== 'string') {
    return <CaseCreator genLink={genLink} />
  }

  return <CaseCreator genLink={genLink} state={{ type: slug, caseId }} />
}

export default CreateCase
